import{jsx as t,Fragment as r,jsxs as n}from"react/jsx-runtime";import o from"styled-components";import{BodyTextStyle as d,BodyText as s}from"../../typography/BodyText/index.js";import"../../shared/media-queries.js";const h=o.li`
  display: flex;
  align-items: center;
  margin: 0;
  text-indent: 0;
  list-style-type: none;
  ${({$onlyLastTruncated:e})=>!e&&`
    overflow: hidden;
  `}

  a {
    ${d}
    font-weight: ${({theme:e})=>e.typography.fontBaseBoldWeight};
    color: ${({theme:e})=>e.colors.info.dark};
    text-decoration: none;
    ${({$onlyLastTruncated:e})=>!e&&`
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  }

  ${({$onlyLastTruncated:e})=>e&&`
    &:last-child {
      overflow: hidden;
    }
  `}
`,c=o(s)`
  color: ${({theme:e})=>e.colors.text.dark};
  overflow: hidden;
  text-overflow: ellipsis;
`,p=o.span`
  display: inline-flex;
  padding-right: 0.5rem;
  svg {
    width: 1rem;
    height: 1rem;
  }
`,m=o.span`
  display: inline-flex;
  padding: 0 0.5rem;
  color: ${({theme:e})=>e.colors.grayscaleToned.light1};
  svg {
    width: 1rem;
    height: 1rem;
  }
`,f=({link:e,separator:i,isLast:l,onlyLastTruncated:a})=>t(r,{children:n(h,{$onlyLastTruncated:a,children:[e.prefixIcon&&t(p,{"aria-hidden":"true",children:e.prefixIcon}),l?t(c,{as:"span","aria-current":"page",children:e.component}):n(r,{children:[e.component,t(m,{"aria-hidden":"true",children:i})]})]})});export{f as default};
